export default __webpack_public_path__ + "static/multi-cloud-2-c9791dbf7cb5c169efb39ce189939ff7.png";